import * as React from 'react';

import {AddReactionButton} from './add-reaction-button';
import {ReactionButton} from './reaction-button';
import type {Reaction, Reactions} from './types';

import styles from './reaction-bar.module.css';

// ReactionBarProps
export type Props = {
    reactions: Reactions;
    onToggleReaction: (reaction: Reaction) => any;
};

type OwnProps = Props & {
    currentUserId: string;
    hideAddButton?: boolean;
    isSmall?: boolean;
};

export function ReactionBar(props: OwnProps) {
    return (
        <div className={props.isSmall ? styles['reaction-bar--small'] : styles['reaction-bar']}>
            {Object.keys(props.reactions).map((reaction) => (
                <ReactionButton
                    key={reaction}
                    // @ts-expect-error
                    reaction={reaction}
                    // @ts-expect-error
                    reactingUsers={props.reactions[reaction]}
                    currentUserId={props.currentUserId}
                    onClick={() => {
                        // @ts-expect-error
                        props.onToggleReaction(reaction);
                    }}
                    isSmall={props.isSmall}
                />
            ))}
            {!props.hideAddButton ? (
                <AddReactionButton onSelectReaction={props.onToggleReaction} />
            ) : undefined}
        </div>
    );
}
